import { Component } from '@angular/core';
import { LoadingController, AlertController, ActionSheetController } from 'ionic-angular';
import { User } from '../../providers/user';



/*
  Generated class for the AccountForgotForm component.

  See https://angular.io/docs/ts/latest/api/core/index/ComponentMetadata-class.html
  for more info on Angular 2 Components.
*/
@Component({
  selector: 'account-forgot-form',
  templateUrl: 'account-forgot-form.html'
})
export class AccountForgotFormComponent {

  login: { email?: string } = {};
  submitted = false;
  constructor(
    public user: User,
    public loading: LoadingController,
    public alert: AlertController,
    public actionSheet: ActionSheetController
  ) { }
  onForgot(form) {
    let loader = this.loading.create({
      content: 'Please wait..',
      duration: 3000
    });

    this.submitted = true;
    if (form.valid) {
      loader.present()
        .then(() => {
          this.user.fb.auth().sendPasswordResetEmail(this.login.email)
            .then(() => {
              loader.dismiss().then(() => {
                this.showAlert('Sucess', 'Email sent verify your inbox.');
              });
            })
            .catch((error) => {
              loader.dismiss().then(() => {
                this.errorHandler(error);
              });
            });
        });
    }
  }

  public showAlert(title, subtitle) {
    let alert = this.alert.create({
      title: title,
      subTitle: subtitle,
      buttons: ['OK']
    });
    alert.present();
  }

  public errorHandler(error) {
    let errorCode = error.code;
    let errorMessage = error.message;
    let handler = User.errorHandler(errorCode, errorMessage);
    this.showAlert(handler.title, handler.message);
  }
}



// WEBPACK FOOTER //
// ./src/components/account-forgot-form/account-forgot-form.ts